import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const finishMyDesign = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    recipe: null,
    isLoadingFinishMyDesign: false
  }
}
export default finishMyDesign;